export default __webpack_public_path__ + "static/kevin-877eef4845c08002b1ee638bf6e195e7.png";